/**
 * Local read contract for invoice lookup within BankDocuments feature.
 * Isolates BankDocuments UI from upstream InvoiceSearch DTO changes.
 */
export interface BankDocumentInvoiceLookup {
  id: number;
  invoiceNumber: string;
  issueDate: string;
  totalAmount: number;
  paidAmount: number;
  remainingAmount: number;
  currency: string;
  applicantFullName: string;
  city?: string | null;
  reservationId?: number | null;
}

export interface BankDocumentInvoiceLookupSource {
  id: number;
  invoiceNumber?: string | null;
  issueDate?: string | null;
  totalAmount?: number | null;
  paidAmount?: number | null;
  remainingAmount?: number | null;
  currency?: string | null;
  applicantFullName?: string | null;
  city?: string | null;
  reservationId?: number | null;
}

export const mapInvoiceToBankDocumentLookup = (
  invoice: BankDocumentInvoiceLookupSource | undefined | null
): BankDocumentInvoiceLookup | undefined => {
  if (!invoice) {
    return undefined;
  }

  const totalAmount = invoice.totalAmount ?? 0;
  const paidAmount = invoice.paidAmount ?? 0;

  return {
    id: invoice.id,
    invoiceNumber: invoice.invoiceNumber ?? `#${invoice.id}`,
    issueDate: invoice.issueDate ?? '',
    totalAmount,
    paidAmount,
    remainingAmount: invoice.remainingAmount ?? Math.max(0, totalAmount - paidAmount),
    currency: invoice.currency ?? 'PLN',
    applicantFullName: invoice.applicantFullName ?? '',
    city: invoice.city ?? null,
    reservationId: invoice.reservationId ?? null,
  };
};
